import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface AmendTransitProps {
  transitId: string;
  name: string;
}

export const useAmendTransit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ transitId, name }: AmendTransitProps): Promise<void> => {
      await request({
        path: `transits/${transitId}/amend`,
        method: 'POST',
        authenticate: true,
        dataObject: { name },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transits'] });
      toast.success('Transit amended!');
    },
    onError: (error) => {
      showErrorToast(error, `Error amending the transit!`);
    },
  });
};
